export enum UserStatusType {
  Active,
  Locked,
  Inactive
}

export const UserStatusTypeValue: Record<UserStatusType, String> = {
  [UserStatusType.Active]: "ACTIVE",
  [UserStatusType.Locked]: "LOCKED",
  [UserStatusType.Inactive]: "INACTIVE"
};
